import { loadBasic } from "tsparticles-basic";
import { options } from "./options";
export async function loadStarsPreset(engine, refresh = true) {
    await loadBasic(engine, false);
    await engine.addPreset("stars", options, refresh);
}
